import Homecontent from "./data/homecontent";
import { Topheader } from "./common/topheader";

import { Innerbanner } from "./common/innerbanner";
import {Footer} from './common/footer';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhoneSquare } from "@fortawesome/free-solid-svg-icons";
function Contactus(){


    return(
<div>
<Topheader></Topheader>
<Innerbanner></Innerbanner>

<div className="container-fluid">

    <div className="container">
<div className="d-flex">
<div className="bg-light shadow p-3 m-3 flex-fill">
    <h3>Best Jyotish in Gurgaon </h3>
    <h4>Bharbav Astro Point</h4>
    <p>Basement, A-142, 40 Feet Rd, <br/>New Palam Vihar Phase 2, Palam Vihar,<br/> Gurugram, Haryana 122017</p>
    <hr></hr>
    <FontAwesomeIcon icon={faPhoneSquare}></FontAwesomeIcon> +987333 6259<br/><br/>
    <FontAwesomeIcon icon={faEnvelope}> </FontAwesomeIcon> bhargaastropoint@gmail.com

    </div>
    <div className="bg-light shadow p-3 m-3 flex-fill">
   
    <FontAwesomeIcon icon={faPhoneSquare}></FontAwesomeIcon> +987333 6259<br/><br/>
    <FontAwesomeIcon icon={faEnvelope}> </FontAwesomeIcon> bhargaastropoint@gmail.com

    </div>


</div>


    </div>



</div>
<Footer></Footer>









</div>






 );







    
}
export {Contactus} ;